// // testing polygons rendering


// import React, { useEffect, useRef } from 'react';
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';

// // The footprints data
// const polygonCoords = [
//   [
//     [
//       [
//         76.6367389912,
//         12.4504860702
//       ],
//       [
//         76.6446903116,
//         12.3962819252
//       ],
//       [
//         76.6526219777,
//         12.3421534708
//       ],
//       [
//         76.6605354688,
//         12.2880909774
//       ],
//       [
//         76.6684322502,
//         12.2340847661
//       ],
//       [
//         76.676313775,
//         12.1801252011
//       ],
//       [
//         76.6841814845,
//         12.1262026822
//       ],
//       [
//         76.69203681,
//         12.0723076379
//       ],
//       [
//         76.6998811735,
//         12.0184305174
//       ],
//       [
//         76.7077159892,
//         11.9645617837
//       ],
//       [
//         76.7155426641,
//         11.9106919064
//       ],
//       [
//         76.7233625998,
//         11.8568113541
//       ],
//       [
//         76.7311771928,
//         11.8029105872
//       ],
//       [
//         76.7389878361,
//         11.7489800511
//       ],
//       [
//         76.7467959201,
//         11.6950101682
//       ],
//       [
//         76.7546028338,
//         11.6409913311
//       ],
//       [
//         76.7624099656,
//         11.5869138948
//       ],
//       [
//         76.7702187046,
//         11.5327681696
//       ],
//       [
//         76.7780304417,
//         11.4785444133
//       ],
//       [
//         76.7858465704,
//         11.4242328237
//       ],
//       [
//         76.8408878635,
//         11.432027288
//       ],
//       [
//         76.8958450918,
//         11.4397939972
//       ],
//       [
//         76.9507281564,
//         11.4475344145
//       ],
//       [
//         77.0055469012,
//         11.455249984
//       ],
//       [
//         77.0603111206,
//         11.4629421314
//       ],
//       [
//         77.1150305673,
//         11.470612265
//       ],
//       [
//         77.1697149594,
//         11.4782617775
//       ],
//       [
//         77.224373988,
//         11.4858920464
//       ],
//       [
//         77.2790173248,
//         11.4935044354
//       ],
//       [
//         77.3336546293,
//         11.5011002954
//       ],
//       [
//         77.3882955562,
//         11.5086809658
//       ],
//       [
//         77.4429497628,
//         11.5162477749
//       ],
//       [
//         77.4976269163,
//         11.5238020416
//       ],
//       [
//         77.552336701,
//         11.5313450757
//       ],
//       [
//         77.607088826,
//         11.5388781797
//       ],
//       [
//         77.6618930324,
//         11.5464026487
//       ],
//       [
//         77.716759101,
//         11.5539197725
//       ],
//       [
//         77.7716968596,
//         11.5614308355
//       ],
//       [
//         77.8267161909,
//         11.5689371185
//       ],
//       [
//         77.8818270402,
//         11.5764398989
//       ],
//       [
//         77.8741300676,
//         11.6307678835
//       ],
//       [
//         77.8664475095,
//         11.6850094449
//       ],
//       [
//         77.8587779556,
//         11.7391743828
//       ],
//       [
//         77.8511200054,
//         11.793272438
//       ],
//       [
//         77.8434722674,
//         11.8473132998
//       ],
//       [
//         77.8358333578,
//         11.9013066137
//       ],
//       [
//         77.8282018997,
//         11.9552619889
//       ],
//       [
//         77.8205765217,
//         12.0091890053
//       ],
//       [
//         77.812955857,
//         12.0630972214
//       ],
//       [
//         77.8053385425,
//         12.1169961812
//       ],
//       [
//         77.7977232172,
//         12.1708954219
//       ],
//       [
//         77.7901085219,
//         12.2248044804
//       ],
//       [
//         77.7824930975,
//         12.2787329015
//       ],
//       [
//         77.7748755842,
//         12.3326902446
//       ],
//       [
//         77.7672546207,
//         12.386686091
//       ],
//       [
//         77.7596288427,
//         12.4407300518
//       ],
//       [
//         77.7519968821,
//         12.4948317744
//       ],
//       [
//         77.744357366,
//         12.5490009508
//       ],
//       [
//         77.7367089154,
//         12.6032473247
//       ],
//       [
//         77.7290501442,
//         12.6575806992
//       ],
//       [
//         77.6737333639,
//         12.649962522
//       ],
//       [
//         77.6185073723,
//         12.64235004
//       ],
//       [
//         77.5633621865,
//         12.6347419154
//       ],
//       [
//         77.5082878854,
//         12.6271368138
//       ],
//       [
//         77.4532746024,
//         12.6195334032
//       ],
//       [
//         77.3983125174,
//         12.6119303534
//       ],
//       [
//         77.3433918492,
//         12.6043263346
//       ],
//       [
//         77.2885028482,
//         12.5967200168
//       ],
//       [
//         77.2336357889,
//         12.5891100683
//       ],
//       [
//         77.178780962,
//         12.581495155
//       ],
//       [
//         77.1239286678,
//         12.5738739395
//       ],
//       [
//         77.0690692081,
//         12.5662450798
//       ],
//       [
//         77.0141928793,
//         12.5586072284
//       ],
//       [
//         76.9592899645,
//         12.5509590316
//       ],
//       [
//         76.9043507268,
//         12.5432991278
//       ],
//       [
//         76.8493654011,
//         12.535626147
//       ],
//       [
//         76.7943241871,
//         12.5279387097
//       ],
//       [
//         76.7392172416,
//         12.5202354253
//       ],
//       [
//         76.6840346707,
//         12.5125148917
//       ],
//       [
//         76.6287665223,
//         12.5047756939
//       ],
//       [
//         76.6367389912,
//         12.4504860702
//       ]
//     ],
//     [
//       [
//         76.5062811782,
//         13.0563206426
//       ],
//       [
//         76.5142747649,
//         13.002129123
//       ],
//       [
//         76.5222484442,
//         12.9480132494
//       ],
//       [
//         76.5302037041,
//         12.8939632947
//       ],
//       [
//         76.5381420186,
//         12.8399695827
//       ],
//       [
//         76.546064849,
//         12.7860224802
//       ],
//       [
//         76.553973645,
//         12.7321123896
//       ],
//       [
//         76.5618698458,
//         12.6782297418
//       ],
//       [
//         76.5697548815,
//         12.6243649886
//       ],
//       [
//         76.5776301737,
//         12.5705085955
//       ],
//       [
//         76.5854971374,
//         12.5166510344
//       ],
//       [
//         76.5933571813,
//         12.4627827765
//       ],
//       [
//         76.6012117094,
//         12.4088942848
//       ],
//       [
//         76.6090621221,
//         12.3549760067
//       ],
//       [
//         76.6169098166,
//         12.3010183674
//       ],
//       [
//         76.6247561891,
//         12.2470117616
//       ],
//       [
//         76.6326026349,
//         12.192946547
//       ],
//       [
//         76.6404505498,
//         12.138813036
//       ],
//       [
//         76.6483013313,
//         12.0846014888
//       ],
//       [
//         76.6561563796,
//         12.0303021058
//       ],
//       [
//         76.711307888,
//         12.0381173513
//       ],
//       [
//         76.7663753394,
//         12.0459042521
//       ],
//       [
//         76.8213686533,
//         12.0536642775
//       ],
//       [
//         76.876297692,
//         12.0613988771
//       ],
//       [
//         76.9311722683,
//         12.0691094818
//       ],
//       [
//         76.986002153,
//         12.0767975047
//       ],
//       [
//         77.0407970827,
//         12.0844643428
//       ],
//       [
//         77.0955667673,
//         12.0921113774
//       ],
//       [
//         77.1503208968,
//         12.0997399759
//       ],
//       [
//         77.2050691496,
//         12.1073514925
//       ],
//       [
//         77.2598211992,
//         12.114947269
//       ],
//       [
//         77.3145867217,
//         12.1225286363
//       ],
//       [
//         77.3693754034,
//         12.1300969152
//       ],
//       [
//         77.4241969478,
//         12.1376534173
//       ],
//       [
//         77.4790610834,
//         12.145199446
//       ],
//       [
//         77.533977571,
//         12.1527362975
//       ],
//       [
//         77.5889562109,
//         12.1602652618
//       ],
//       [
//         77.644006851,
//         12.1677876237
//       ],
//       [
//         77.6991393942,
//         12.1753046632
//       ],
//       [
//         77.7543638061,
//         12.1828176574
//       ],
//       [
//         77.7466393119,
//         12.2371350247
//       ],
//       [
//         77.7389291148,
//         12.2913659672
//       ],
//       [
//         77.7312318002,
//         12.3455202826
//       ],
//       [
//         77.7235459631,
//         12.3996077095
//       ],
//       [
//         77.7158702077,
//         12.4536379354
//       ],
//       [
//         77.7082031456,
//         12.5076206035
//       ],
//       [
//         77.7005433951,
//         12.5615653208
//       ],
//       [
//         77.6928895801,
//         12.6154816655
//       ],
//       [
//         77.6852403289,
//         12.6693791938
//       ],
//       [
//         77.6775942734,
//         12.7232674476
//       ],
//       [
//         77.6699500475,
//         12.7771559619
//       ],
//       [
//         77.6623062868,
//         12.8310542716
//       ],
//       [
//         77.6546616269,
//         12.8849719193
//       ],
//       [
//         77.6470147025,
//         12.9389184623
//       ],
//       [
//         77.6393641468,
//         12.9929034797
//       ],
//       [
//         77.6317085897,
//         13.0469365802
//       ],
//       [
//         77.6240466573,
//         13.1010274092
//       ],
//       [
//         77.6163769707,
//         13.1551856563
//       ],
//       [
//         77.6086981447,
//         13.2094210631
//       ],
//       [
//         77.6010087871,
//         13.2637434301
//       ],
//       [
//         77.5455667853,
//         13.2561134828
//       ],
//       [
//         77.4902159432,
//         13.2484886832
//       ],
//       [
//         77.4349462549,
//         13.2408676939
//       ],
//       [
//         77.3797477769,
//         13.2332491804
//       ],
//       [
//         77.3246106202,
//         13.2256318106
//       ],
//       [
//         77.2695249425,
//         13.2180142535
//       ],
//       [
//         77.214480941,
//         13.2103951782
//       ],
//       [
//         77.1594688442,
//         13.202773253
//       ],
//       [
//         77.104478905,
//         13.1951471444
//       ],
//       [
//         77.049501393,
//         13.1875155162
//       ],
//       [
//         76.994526587,
//         13.179877028
//       ],
//       [
//         76.9395447678,
//         13.1722303349
//       ],
//       [
//         76.8845462106,
//         13.164574086
//       ],
//       [
//         76.8295211779,
//         13.1569069235
//       ],
//       [
//         76.7744599117,
//         13.1492274816
//       ],
//       [
//         76.7193526263,
//         13.1415343858
//       ],
//       [
//         76.6641895005,
//         13.1338262512
//       ],
//       [
//         76.6089606704,
//         13.1261016819
//       ],
//       [
//         76.5536562216,
//         13.1183592698
//       ],
//       [
//         76.4982661811,
//         13.1105975934
//       ],
//       [
//         76.5062811782,
//         13.0563206426
//       ]
//     ],
//     [
//       [
//         76.3753224679,
//         13.6621112287
//       ],
//       [
//         76.3833604349,
//         13.6079323564
//       ],
//       [
//         76.3913782345,
//         13.5538290852
//       ],
//       [
//         76.3993773636,
//         13.4997916906
//       ],
//       [
//         76.4073593054,
//         13.4458104991
//       ],
//       [
//         76.4153255297,
//         13.3918758799
//       ],
//       [
//         76.423277495,
//         13.3379782382
//       ],
//       [
//         76.4312166489,
//         13.2841080073
//       ],
//       [
//         76.4391444297,
//         13.2302556416
//       ],
//       [
//         76.4470622673,
//         13.176411609
//       ],
//       [
//         76.4549715845,
//         13.122566384
//       ],
//       [
//         76.4628737981,
//         13.06871044
//       ],
//       [
//         76.4707703197,
//         13.0148342426
//       ],
//       [
//         76.4786625571,
//         12.9609282417
//       ],
//       [
//         76.4865519153,
//         12.9069828647
//       ],
//       [
//         76.4944397977,
//         12.8529885088
//       ],
//       [
//         76.5023276069,
//         12.7989355341
//       ],
//       [
//         76.5102167458,
//         12.7448142554
//       ],
//       [
//         76.5181086191,
//         12.6906149354
//       ],
//       [
//         76.5260046338,
//         12.6363277765
//       ],
//       [
//         76.5812730877,
//         12.6441647632
//       ],
//       [
//         76.6364574851,
//         12.651972812
//       ],
//       [
//         76.6915677649,
//         12.6597533985
//       ],
//       [
//         76.7466138088,
//         12.667507978
//       ],
//       [
//         76.8016054493,
//         12.6752379866
//       ],
//       [
//         76.8565524767,
//         12.6829448426
//       ],
//       [
//         76.9114646472,
//         12.6906299471
//       ],
//       [
//         76.9663516903,
//         12.698294686
//       ],
//       [
//         77.0212233159,
//         12.70594043
//       ],
//       [
//         77.0760892222,
//         12.7135685368
//       ],
//       [
//         77.1309591026,
//         12.7211803511
//       ],
//       [
//         77.1858426534,
//         12.7287772064
//       ],
//       [
//         77.2407495811,
//         12.7363604255
//       ],
//       [
//         77.2956896096,
//         12.7439313218
//       ],
//       [
//         77.3506724879,
//         12.7514912001
//       ],
//       [
//         77.4057079975,
//         12.7590413576
//       ],
//       [
//         77.4608059598,
//         12.7665830849
//       ],
//       [
//         77.5159762437,
//         12.7741176669
//       ],
//       [
//         77.5712287736,
//         12.7816463836
//       ],
//       [
//         77.6265735366,
//         12.7891705113
//       ],
//       [
//         77.6188195799,
//         12.8434772592
//       ],
//       [
//         77.6110798041,
//         12.8976975808
//       ],
//       [
//         77.6033527897,
//         12.9518412716
//       ],
//       [
//         77.5956371272,
//         13.0059180683
//       ],
//       [
//         77.5879314158,
//         13.0599376561
//       ],
//       [
//         77.5802342621,
//         13.1139096763
//       ],
//       [
//         77.5725442795,
//         13.1678437339
//       ],
//       [
//         77.5648600868,
//         13.2217494048
//       ],
//       [
//         77.557180307,
//         13.2756362432
//       ],
//       [
//         77.5495035666,
//         13.329513789
//       ],
//       [
//         77.5418284941,
//         13.383391575
//       ],
//       [
//         77.5341537195,
//         13.437279134
//       ],
//       [
//         77.5264778727,
//         13.4911860064
//       ],
//       [
//         77.5187995827,
//         13.5451217473
//       ],
//       [
//         77.5111174766,
//         13.5990959338
//       ],
//       [
//         77.5034301783,
//         13.6531181722
//       ],
//       [
//         77.4957363077,
//         13.7071981058
//       ],
//       [
//         77.4880344795,
//         13.761345422
//       ],
//       [
//         77.4803233021,
//         13.8155698598
//       ],
//       [
//         77.4726013763,
//         13.8698812178
//       ],
//       [
//         77.4170272421,
//         13.8622385645
//       ],
//       [
//         77.3615446522,
//         13.8546005105
//       ],
//       [
//         77.3061435768,
//         13.8469657185
//       ],
//       [
//         77.2508140487,
//         13.8393328542
//       ],
//       [
//         77.1955461552,
//         13.8317005848
//       ],
//       [
//         77.140330031,
//         13.8240675785
//       ],
//       [
//         77.0851558499,
//         13.8164325031
//       ],
//       [
//         77.0300138176,
//         13.8087940253
//       ],
//       [
//         76.9748941643,
//         13.8011508094
//       ],
//       [
//         76.919787137,
//         13.7935015167
//       ],
//       [
//         76.864682992,
//         13.7858448042
//       ],
//       [
//         76.809571988,
//         13.7781793236
//       ],
//       [
//         76.7544443779,
//         13.7705037203
//       ],
//       [
//         76.699290402,
//         13.7628166326
//       ],
//       [
//         76.6441002804,
//         13.7551166902
//       ],
//       [
//         76.5888642052,
//         13.7474025136
//       ],
//       [
//         76.5335723336,
//         13.7396727128
//       ],
//       [
//         76.4782147797,
//         13.7319258862
//       ],
//       [
//         76.4227816069,
//         13.7241606195
//       ],
//       [
//         76.3672628208,
//         13.7163754847
//       ],
//       [
//         76.3753224679,
//         13.6621112287
//       ]
//     ],
//     [
//       [
//         76.243839303,
//         14.2678547113
//       ],
//       [
//         76.2519238057,
//         14.2136885115
//       ],
//       [
//         76.2599878733,
//         14.1595978677
//       ],
//       [
//         76.2680330126,
//         14.105573058
//       ],
//       [
//         76.2760607159,
//         14.0516044115
//       ],
//       [
//         76.2840724624,
//         13.9976823
//       ],
//       [
//         76.2920697195,
//         13.9437971312
//       ],
//       [
//         76.3000539437,
//         13.889939341
//       ],
//       [
//         76.308026582,
//         13.8360993863
//       ],
//       [
//         76.3159890729,
//         13.7822677375
//       ],
//       [
//         76.3239428474,
//         13.7284348715
//       ],
//       [
//         76.3318893307,
//         13.6745912643
//       ],
//       [
//         76.3398299424,
//         13.6207273837
//       ],
//       [
//         76.3477660984,
//         13.5668336823
//       ],
//       [
//         76.3556992115,
//         13.5129005897
//       ],
//       [
//         76.3636306929,
//         13.4589185056
//       ],
//       [
//         76.3715619527,
//         13.4048777924
//       ],
//       [
//         76.3794944015,
//         13.3507687674
//       ],
//       [
//         76.3874294513,
//         13.2965816956
//       ],
//       [
//         76.3953685166,
//         13.2423067819
//       ],
//       [
//         76.450760712,
//         13.250166481
//       ],
//       [
//         76.506068844,
//         13.2579966452
//       ],
//       [
//         76.5613028721,
//         13.2657987567
//       ],
//       [
//         76.6164726987,
//         13.2735742766
//       ],
//       [
//         76.671588177,
//         13.2813246464
//       ],
//       [
//         76.726659118,
//         13.2890512896
//       ],
//       [
//         76.7816952989,
//         13.296755612
//       ],
//       [
//         76.8367064697,
//         13.3044390036
//       ],
//       [
//         76.8917023616,
//         13.3121028393
//       ],
//       [
//         76.9466926935,
//         13.3197484799
//       ],
//       [
//         77.0016871801,
//         13.3273772735
//       ],
//       [
//         77.056695539,
//         13.3349905561
//       ],
//       [
//         77.111727498,
//         13.3425896528
//       ],
//       [
//         77.1667928027,
//         13.350175879
//       ],
//       [
//         77.2219012238,
//         13.357750541
//       ],
//       [
//         77.2770625646,
//         13.3653149372
//       ],
//       [
//         77.3322866688,
//         13.3728703588
//       ],
//       [
//         77.3875834277,
//         13.3804180911
//       ],
//       [
//         77.4429627881,
//         13.3879594141
//       ],
//       [
//         77.4984347601,
//         13.3954956037
//       ],
//       [
//         77.49064937,
//         13.4497917281
//       ],
//       [
//         77.4828780454,
//         13.5040014245
//       ],
//       [
//         77.4751193619,
//         13.5581344864
//       ],
//       [
//         77.4673719048,
//         13.6122006486
//       ],
//       [
//         77.459634268,
//         13.6662095941
//       ],
//       [
//         77.4519050529,
//         13.7201709622
//       ],
//       [
//         77.4441828676,
//         13.7740943557
//       ],
//       [
//         77.4364663253,
//         13.8279893486
//       ],
//       [
//         77.4287540433,
//         13.8818654929
//       ],
//       [
//         77.4210446426,
//         13.9357323265
//       ],
//       [
//         77.4133367458,
//         13.9895993799
//       ],
//       [
//         77.405628977,
//         14.0434761839
//       ],
//       [
//         77.3979199599,
//         14.0973722769
//       ],
//       [
//         77.3902083175,
//         14.1512972116
//       ],
//       [
//         77.3824926704,
//         14.2052605629
//       ],
//       [
//         77.3747716362,
//         14.2592719352
//       ],
//       [
//         77.3670438281,
//         14.3133409693
//       ],
//       [
//         77.3593078541,
//         14.3674773503
//       ],
//       [
//         77.3515623157,
//         14.4216908152
//       ],
//       [
//         77.3438058067,
//         14.47599116
//       ],
//       [
//         77.288092552,
//         14.4683348552
//       ],
//       [
//         77.2324712405,
//         14.4606826002
//       ],
//       [
//         77.1769318172,
//         14.4530330579
//       ],
//       [
//         77.1214642898,
//         14.4453848938
//       ],
//       [
//         77.066058721,
//         14.4377367743
//       ],
//       [
//         77.0107052207,
//         14.4300873667
//       ],
//       [
//         76.9553939385,
//         14.4224353373
//       ],
//       [
//         76.9001150561,
//         14.4147793509
//       ],
//       [
//         76.8448587796,
//         14.4071180697
//       ],
//       [
//         76.7896153323,
//         14.3994501524
//       ],
//       [
//         76.734374947,
//         14.3917742528
//       ],
//       [
//         76.6791278587,
//         14.3840890193
//       ],
//       [
//         76.6238642969,
//         14.3763930936
//       ],
//       [
//         76.5685744788,
//         14.3686851096
//       ],
//       [
//         76.513248601,
//         14.3609636926
//       ],
//       [
//         76.4578768327,
//         14.3532274579
//       ],
//       [
//         76.4024493078,
//         14.3454750101
//       ],
//       [
//         76.3469561172,
//         14.3377049417
//       ],
//       [
//         76.2913873016,
//         14.3299158322
//       ],
//       [
//         76.235732843,
//         14.3221062468
//       ],
//       [
//         76.243839303,
//         14.2678547113
//       ]
//     ]
//   ],
//   [
//     [
//       [
//         76.8544953576,
//         12.4468089578
//       ],
//       [
//         76.8623154475,
//         12.3934805551
//       ],
//       [
//         76.8701163746,
//         12.3402264551
//       ],
//       [
//         76.877899589,
//         12.2870371092
//       ],
//       [
//         76.8856665276,
//         12.2339030182
//       ],
//       [
//         76.8934186147,
//         12.1808147252
//       ],
//       [
//         76.9011572638,
//         12.1277628083
//       ],
//       [
//         76.9088838785,
//         12.0747378733
//       ],
//       [
//         76.9165998533,
//         12.0217305465
//       ],
//       [
//         76.9243065751,
//         11.9687314678
//       ],
//       [
//         76.9320054242,
//         11.9157312833
//       ],
//       [
//         76.9396977752,
//         11.8627206382
//       ],
//       [
//         76.9473849981,
//         11.8096901699
//       ],
//       [
//         76.9550684596,
//         11.756630501
//       ],
//       [
//         76.9627495237,
//         11.7035322315
//       ],
//       [
//         76.9704295533,
//         11.6503859325
//       ],
//       [
//         76.9781099107,
//         11.5971821381
//       ],
//       [
//         76.985791959,
//         11.5439113389
//       ],
//       [
//         76.993477063,
//         11.4905639741
//       ],
//       [
//         77.0011665903,
//         11.4371304241
//       ],
//       [
//         77.0553207423,
//         11.444796885
//       ],
//       [
//         77.1093923375,
//         11.4524363123
//       ],
//       [
//         77.1633910934,
//         11.460050141
//       ],
//       [
//         77.2173266716,
//         11.4676397872
//       ],
//       [
//         77.2712086853,
//         11.4752066492
//       ],
//       [
//         77.3250467067,
//         11.4827521087
//       ],
//       [
//         77.3788502741,
//         11.4902775319
//       ],
//       [
//         77.4326288998,
//         11.4977842706
//       ],
//       [
//         77.4863920766,
//         11.505273663
//       ],
//       [
//         77.5401492856,
//         11.512747035
//       ],
//       [
//         77.5939100032,
//         11.5202057013
//       ],
//       [
//         77.647683708,
//         11.5276509661
//       ],
//       [
//         77.7014798886,
//         11.5350841241
//       ],
//       [
//         77.7553080502,
//         11.542506462
//       ],
//       [
//         77.8091777221,
//         11.5499192584
//       ],
//       [
//         77.8630984651,
//         11.557323786
//       ],
//       [
//         77.9170798786,
//         11.5647213114
//       ],
//       [
//         77.971131608,
//         11.5721130968
//       ],
//       [
//         78.0252633523,
//         11.5795004005
//       ],
//       [
//         78.0794848719,
//         11.5868844781
//       ],
//       [
//         78.0719108855,
//         11.6403339262
//       ],
//       [
//         78.0643510089,
//         11.6936985518
//       ],
//       [
//         78.056803858,
//         11.7469879722
//       ],
//       [
//         78.0492680588,
//         11.8002117468
//       ],
//       [
//         78.0417422458,
//         11.8533793846
//       ],
//       [
//         78.0342250613,
//         11.9065003519
//       ],
//       [
//         78.026715154,
//         11.9595840795
//       ],
//       [
//         78.0192111781,
//         12.0126399694
//       ],
//       [
//         78.0117117923,
//         12.065677403
//       ],
//       [
//         78.0042156586,
//         12.118705747
//       ],
//       [
//         77.9967214417,
//         12.1717343618
//       ],
//       [
//         77.9892278072,
//         12.2247726076
//       ],
//       [
//         77.9817334214,
//         12.2778298519
//       ],
//       [
//         77.9742369497,
//         12.3309154769
//       ],
//       [
//         77.966737056,
//         12.3840388861
//       ],
//       [
//         77.9592324011,
//         12.4372095118
//       ],
//       [
//         77.9517216424,
//         12.4904368224
//       ],
//       [
//         77.9442034321,
//         12.5437303294
//       ],
//       [
//         77.9366764169,
//         12.5970995952
//       ],
//       [
//         77.9291392363,
//         12.65055424
//       ],
//       [
//         77.8747183618,
//         12.6430584562
//       ],
//       [
//         77.8203865525,
//         12.6355683489
//       ],
//       [
//         77.7661340119,
//         12.6280826042
//       ],
//       [
//         77.7119510039,
//         12.6205999118
//       ],
//       [
//         77.6578278458,
//         12.6131189639
//       ],
//       [
//         77.6037549001,
//         12.6056384545
//       ],
//       [
//         77.5497225677,
//         12.598157078
//       ],
//       [
//         77.4957212799,
//         12.5906735285
//       ],
//       [
//         77.4417414919,
//         12.5831864987
//       ],
//       [
//         77.3877736748,
//         12.575694679
//       ],
//       [
//         77.3338083087,
//         12.5681967564
//       ],
//       [
//         77.2798358754,
//         12.5606914139
//       ],
//       [
//         77.2258468512,
//         12.5531773287
//       ],
//       [
//         77.1718316998,
//         12.5456531722
//       ],
//       [
//         77.1177808648,
//         12.5381176082
//       ],
//       [
//         77.0636847625,
//         12.5305692922
//       ],
//       [
//         77.0095337746,
//         12.5230068704
//       ],
//       [
//         76.955318241,
//         12.5154289786
//       ],
//       [
//         76.9010284518,
//         12.5078342409
//       ],
//       [
//         76.8466546404,
//         12.500221269
//       ],
//       [
//         76.8544953576,
//         12.4468089578
//       ]
//     ],
//     [
//       [
//         76.7238040958,
//         13.0545480013
//       ],
//       [
//         76.7316654818,
//         13.0012341091
//       ],
//       [
//         76.73950746,
//         12.9479944729
//       ],
//       [
//         76.7473314889,
//         12.8948195469
//       ],
//       [
//         76.7551390136,
//         12.841699835
//       ],
//       [
//         76.7629314668,
//         12.7886258833
//       ],
//       [
//         76.7707102697,
//         12.7355882727
//       ],
//       [
//         76.7784768338,
//         12.682577612
//       ],
//       [
//         76.7862325614,
//         12.6295845304
//       ],
//       [
//         76.7939788468,
//         12.5765996705
//       ],
//       [
//         76.8017170778,
//         12.5236136813
//       ],
//       [
//         76.8094486361,
//         12.470617211
//       ],
//       [
//         76.8171748991,
//         12.4176008997
//       ],
//       [
//         76.8248972403,
//         12.3645553726
//       ],
//       [
//         76.8326170307,
//         12.3114712328
//       ],
//       [
//         76.84033564,
//         12.2583390539
//       ],
//       [
//         76.8480544373,
//         12.2051493729
//       ],
//       [
//         76.8557747921,
//         12.1518926832
//       ],
//       [
//         76.8634980759,
//         12.0985594267
//       ],
//       [
//         76.8712256626,
//         12.0451399866
//       ],
//       [
//         76.925486653,
//         12.0528265889
//       ],
//       [
//         76.979665095,
//         12.0604855864
//       ],
//       [
//         77.033770724,
//         12.06811842
//       ],
//       [
//         77.0878132192,
//         12.0757265112
//       ],
//       [
//         77.1418022114,
//         12.0833112633
//       ],
//       [
//         77.1957472905,
//         12.0908740625
//       ],
//       [
//         77.2496580128,
//         12.0984162793
//       ],
//       [
//         77.3035439083,
//         12.1059392691
//       ],
//       [
//         77.3574144878,
//         12.1134443737
//       ],
//       [
//         77.4112792504,
//         12.1209329221
//       ],
//       [
//         77.4651476906,
//         12.1284062315
//       ],
//       [
//         77.5190293054,
//         12.1358656084
//       ],
//       [
//         77.5729336017,
//         12.1433123497
//       ],
//       [
//         77.6268701031,
//         12.1507477431
//       ],
//       [
//         77.6808483579,
//         12.1581730689
//       ],
//       [
//         77.7348779454,
//         12.1655896003
//       ],
//       [
//         77.7889684843,
//         12.1729986044
//       ],
//       [
//         77.8431296392,
//         12.1804013435
//       ],
//       [
//         77.8973711286,
//         12.1877990756
//       ],
//       [
//         77.9517027324,
//         12.1951930554
//       ],
//       [
//         77.9441017466,
//         12.2486299357
//       ],
//       [
//         77.9365147566,
//         12.3019819962
//       ],
//       [
//         77.9289403741,
//         12.3552588513
//       ],
//       [
//         77.9213772208,
//         12.4084700582
//       ],
//       [
//         77.9138239268,
//         12.4616251235
//       ],
//       [
//         77.9062791299,
//         12.514733511
//       ],
//       [
//         77.8987414743,
//         12.5678046488
//       ],
//       [
//         77.8912096095,
//         12.6208479369
//       ],
//       [
//         77.8836821894,
//         12.6738727536
//       ],
//       [
//         77.8761578712,
//         12.7268884637
//       ],
//       [
//         77.8686353146,
//         12.7799044248
//       ],
//       [
//         77.8611131801,
//         12.8329299946
//       ],
//       [
//         77.8535901287,
//         12.8859745381
//       ],
//       [
//         77.8460648207,
//         12.939047435
//       ],
//       [
//         77.8385359143,
//         12.9921580862
//       ],
//       [
//         77.831002065,
//         13.0453159214
//       ],
//       [
//         77.8234619243,
//         13.0985304063
//       ],
//       [
//         77.8159141386,
//         13.1518110499
//       ],
//       [
//         77.8083573487,
//         13.2051674118
//       ],
//       [
//         77.8007901878,
//         13.2586091096
//       ],
//       [
//         77.7462479249,
//         13.2511019205
//       ],
//       [
//         77.6917950858,
//         13.2435998765
//       ],
//       [
//         77.637421852,
//         13.2361016643
//       ],
//       [
//         77.5831184658,
//         13.2286059737
//       ],
//       [
//         77.5288752228,
//         13.2211114966
//       ],
//       [
//         77.4746824643,
//         13.2136169261
//       ],
//       [
//         77.42053057,
//         13.2061209557
//       ],
//       [
//         77.3664099505,
//         13.1986222779
//       ],
//       [
//         77.3123110399,
//         13.1911195837
//       ],
//       [
//         77.2582242889,
//         13.1836115612
//       ],
//       [
//         77.2041401569,
//         13.1760968949
//       ],
//       [
//         77.1500491056,
//         13.1685742647
//       ],
//       [
//         77.0959415909,
//         13.1610423446
//       ],
//       [
//         77.0418080562,
//         13.1534998021
//       ],
//       [
//         76.9876389252,
//         13.1459452969
//       ],
//       [
//         76.933424594,
//         13.1383774801
//       ],
//       [
//         76.8791554245,
//         13.1307949929
//       ],
//       [
//         76.8248217364,
//         13.1231964656
//       ],
//       [
//         76.7704138,
//         13.1155805168
//       ],
//       [
//         76.7159218286,
//         13.107945752
//       ],
//       [
//         76.7238040958,
//         13.0545480013
//       ]
//     ],
//     [
//       [
//         76.592608336,
//         13.662247896
//       ],
//       [
//         76.6005131219,
//         13.6089484332
//       ],
//       [
//         76.6083982479,
//         13.5557231794
//       ],
//       [
//         76.6162651816,
//         13.502562592
//       ],
//       [
//         76.6241153765,
//         13.4494571777
//       ],
//       [
//         76.6319502739,
//         13.3963974856
//       ],
//       [
//         76.6397713036,
//         13.3433740996
//       ],
//       [
//         76.6475798852,
//         13.2903776312
//       ],
//       [
//         76.655377429,
//         13.2373987127
//       ],
//       [
//         76.6631653373,
//         13.1844279893
//       ],
//       [
//         76.6709450056,
//         13.131456113
//       ],
//       [
//         76.6787178234,
//         13.0784737346
//       ],
//       [
//         76.6864851754,
//         13.0254714972
//       ],
//       [
//         76.6942484426,
//         12.9724400286
//       ],
//       [
//         76.7020090034,
//         12.9193699348
//       ],
//       [
//         76.7097682346,
//         12.866251792
//       ],
//       [
//         76.7175275122,
//         12.8130761402
//       ],
//       [
//         76.725288213,
//         12.7598334753
//       ],
//       [
//         76.7330517151,
//         12.706514242
//       ],
//       [
//         76.7408193994,
//         12.6531088263
//       ],
//       [
//         76.7951939894,
//         12.6608165334
//       ],
//       [
//         76.849486032,
//         12.6684960612
//       ],
//       [
//         76.9037052813,
//         12.6761488564
//       ],
//       [
//         76.9578614353,
//         12.683776346
//       ],
//       [
//         77.011964144,
//         12.6913799386
//       ],
//       [
//         77.0660230159,
//         12.6989610251
//       ],
//       [
//         77.1200476264,
//         12.7065209803
//       ],
//       [
//         77.1740475244,
//         12.7140611637
//       ],
//       [
//         77.22803224,
//         12.7215829206
//       ],
//       [
//         77.2820112914,
//         12.7290875832
//       ],
//       [
//         77.3359941924,
//         12.7365764716
//       ],
//       [
//         77.3899904594,
//         12.7440508947
//       ],
//       [
//         77.4440096188,
//         12.7515121513
//       ],
//       [
//         77.4980612141,
//         12.7589615312
//       ],
//       [
//         77.5521548133,
//         12.7664003157
//       ],
//       [
//         77.6063000159,
//         12.773829779
//       ],
//       [
//         77.6605064607,
//         12.7812511889
//       ],
//       [
//         77.7147838328,
//         12.7886658077
//       ],
//       [
//         77.7691418714,
//         12.7960748934
//       ],
//       [
//         77.8235903773,
//         12.8034797001
//       ],
//       [
//         77.8159604563,
//         12.8569041132
//       ],
//       [
//         77.808344418,
//         12.9102437088
//       ],
//       [
//         77.80074087,
//         12.963508099
//       ],
//       [
//         77.793148429,
//         13.0167068383
//       ],
//       [
//         77.7855657206,
//         13.069849431
//       ],
//       [
//         77.7779913776,
//         13.1229453385
//       ],
//       [
//         77.7704240393,
//         13.1760039864
//       ],
//       [
//         77.7628623502,
//         13.2290347722
//       ],
//       [
//         77.7553049592,
//         13.2820470719
//       ],
//       [
//         77.7477505182,
//         13.3350502477
//       ],
//       [
//         77.7401976813,
//         13.3880536548
//       ],
//       [
//         77.732645104,
//         13.4410666483
//       ],
//       [
//         77.7250914416,
//         13.494098591
//       ],
//       [
//         77.7175353485,
//         13.5471588597
//       ],
//       [
//         77.7099754773,
//         13.6002568529
//       ],
//       [
//         77.7024104775,
//         13.6534019977
//       ],
//       [
//         77.6948389945,
//         13.7066037573
//       ],
//       [
//         77.6872596686,
//         13.7598716381
//       ],
//       [
//         77.679671134,
//         13.8132151968
//       ],
//       [
//         77.6720720178,
//         13.8666440486
//       ],
//       [
//         77.6174014299,
//         13.8591245135
//       ],
//       [
//         77.5628206384,
//         13.8516095915
//       ],
//       [
//         77.5083198015,
//         13.8440979696
//       ],
//       [
//         77.4538891383,
//         13.8365883374
//       ],
//       [
//         77.3995189219,
//         13.8290793864
//       ],
//       [
//         77.345199471,
//         13.8215698089
//       ],
//       [
//         77.2909211429,
//         13.814058297
//       ],
//       [
//         77.236674326,
//         13.8065435418
//       ],
//       [
//         77.1824494327,
//         13.7990242321
//       ],
//       [
//         77.1282368916,
//         13.7914990538
//       ],
//       [
//         77.0740271407,
//         13.7839666886
//       ],
//       [
//         77.0198106198,
//         13.7764258131
//       ],
//       [
//         76.9655777637,
//         13.768875098
//       ],
//       [
//         76.9113189942,
//         13.7613132067
//       ],
//       [
//         76.8570247137,
//         13.7537387948
//       ],
//       [
//         76.8026852971,
//         13.7461505085
//       ],
//       [
//         76.7482910852,
//         13.738546984
//       ],
//       [
//         76.6938323763,
//         13.7309268462
//       ],
//       [
//         76.6392994198,
//         13.7232887076
//       ],
//       [
//         76.5846824076,
//         13.7156311674
//       ],
//       [
//         76.592608336,
//         13.662247896
//       ]
//     ],
//     [
//       [
//         76.4608843291,
//         14.2699052772
//       ],
//       [
//         76.4688346595,
//         14.2166201659
//       ],
//       [
//         76.4767650706,
//         14.1634092165
//       ],
//       [
//         76.4846770394,
//         14.1102628895
//       ],
//       [
//         76.4925720286,
//         14.0571716945
//       ],
//       [
//         76.5004514884,
//         14.0041261836
//       ],
//       [
//         76.5083168574,
//         13.9511169436
//       ],
//       [
//         76.5161695637,
//         13.8981345888
//       ],
//       [
//         76.5240110262,
//         13.8451697543
//       ],
//       [
//         76.5318426556,
//         13.7922130883
//       ],
//       [
//         76.5396658553,
//         13.7392552454
//       ],
//       [
//         76.547482023,
//         13.6862868793
//       ],
//       [
//         76.5552925513,
//         13.6332986358
//       ],
//       [
//         76.5630988291,
//         13.5802811455
//       ],
//       [
//         76.5709022423,
//         13.527225017
//       ],
//       [
//         76.5787041752,
//         13.4741208295
//       ],
//       [
//         76.5865060114,
//         13.4209591256
//       ],
//       [
//         76.594309135,
//         13.3677304038
//       ],
//       [
//         76.6021149314,
//         13.3144251117
//       ],
//       [
//         76.6099247885,
//         13.261033638
//       ],
//       [
//         76.664419805,
//         13.2687634247
//       ],
//       [
//         76.7188322675,
//         13.2764644537
//       ],
//       [
//         76.7731719502,
//         13.284138178
//       ],
//       [
//         76.8274485712,
//         13.2917860303
//       ],
//       [
//         76.8816718002,
//         13.2994094244
//       ],
//       [
//         76.9358512662,
//         13.3070097563
//       ],
//       [
//         76.9899965646,
//         13.3145884052
//       ],
//       [
//         77.0441172645,
//         13.3221467347
//       ],
//       [
//         77.0982229162,
//         13.329686094
//       ],
//       [
//         77.1523230583,
//         13.3372078186
//       ],
//       [
//         77.2064272252,
//         13.3447132315
//       ],
//       [
//         77.2605449538,
//         13.3522036443
//       ],
//       [
//         77.3146857914,
//         13.3596803581
//       ],
//       [
//         77.3688593022,
//         13.3671446644
//       ],
//       [
//         77.4230750753,
//         13.3745978461
//       ],
//       [
//         77.4773427317,
//         13.3820411785
//       ],
//       [
//         77.5316719313,
//         13.38947593
//       ],
//       [
//         77.586072381,
//         13.3969033635
//       ],
//       [
//         77.640553842,
//         13.4043247368
//       ],
//       [
//         77.6951261371,
//         13.4117413036
//       ],
//       [
//         77.6874653148,
//         13.4651533481
//       ],
//       [
//         77.6798182635,
//         13.5184805772
//       ],
//       [
//         77.6721835855,
//         13.5717326006
//       ],
//       [
//         77.6645598929,
//         13.6249189704
//       ],
//       [
//         77.656945806,
//         13.6780491884
//       ],
//       [
//         77.6493399525,
//         13.7311327137
//       ],
//       [
//         77.6417409663,
//         13.7841789695
//       ],
//       [
//         77.6341474866,
//         13.8371973507
//       ],
//       [
//         77.6265581567,
//         13.8901972311
//       ],
//       [
//         77.6189716231,
//         13.9431879703
//       ],
//       [
//         77.6113865342,
//         13.996178921
//       ],
//       [
//         77.6038015395,
//         14.0491794361
//       ],
//       [
//         77.5962152885,
//         14.1021988756
//       ],
//       [
//         77.5886264295,
//         14.1552466139
//       ],
//       [
//         77.5810336091,
//         14.2083320471
//       ],
//       [
//         77.5734354702,
//         14.2614645997
//       ],
//       [
//         77.5658306519,
//         14.3146537323
//       ],
//       [
//         77.558217788,
//         14.3679089485
//       ],
//       [
//         77.5505955059,
//         14.4212398028
//       ],
//       [
//         77.5429624256,
//         14.4746559073
//       ],
//       [
//         77.4881564997,
//         14.467123076
//       ],
//       [
//         77.4334407568,
//         14.4595943249
//       ],
//       [
//         77.3788053306,
//         14.4520683411
//       ],
//       [
//         77.324240416,
//         14.444543814
//       ],
//       [
//         77.2697362621,
//         14.4370194345
//       ],
//       [
//         77.2152831637,
//         14.4294938937
//       ],
//       [
//         77.1608714549,
//         14.4219658825
//       ],
//       [
//         77.1064915005,
//         14.4144340901
//       ],
//       [
//         77.0521336897,
//         14.4068972033
//       ],
//       [
//         76.9977884281,
//         14.3993539053
//       ],
//       [
//         76.9434461309,
//         14.3918028749
//       ],
//       [
//         76.889097215,
//         14.3842427855
//       ],
//       [
//         76.8347320926,
//         14.376672304
//       ],
//       [
//         76.780341163,
//         14.3690900898
//       ],
//       [
//         76.725914806,
//         14.361494794
//       ],
//       [
//         76.6714433742,
//         14.3538850579
//       ],
//       [
//         76.6169171857,
//         14.3462595125
//       ],
//       [
//         76.5623265167,
//         14.3386167769
//       ],
//       [
//         76.5076615941,
//         14.3309554576
//       ],
//       [
//         76.4529125876,
//         14.3232741472
//       ],
//       [
//         76.4608843291,
//         14.2699052772
//       ]
//     ]
//   ],
//   [
//     [
//       [
//         77.9611940967,
//         12.5974155936
//       ],
//       [
//         77.9691043381,
//         12.5435558318
//       ],
//       [
//         77.9769950568,
//         12.4897712082
//       ],
//       [
//         77.984867723,
//         12.4360520645
//       ],
//       [
//         77.9927237927,
//         12.3823887925
//       ],
//       [
//         78.0005647099,
//         12.3287718269
//       ],
//       [
//         78.0083919069,
//         12.2751916378
//       ],
//       [
//         78.0162068062,
//         12.2216387234
//       ],
//       [
//         78.0240108209,
//         12.1681036027
//       ],
//       [
//         78.0318053564,
//         12.1145768082
//       ],
//       [
//         78.0395918111,
//         12.0610488791
//       ],
//       [
//         78.0473715777,
//         12.0075103534
//       ],
//       [
//         78.0551460442,
//         11.9539517614
//       ],
//       [
//         78.0629165951,
//         11.900363618
//       ],
//       [
//         78.0706846122,
//         11.8467364156
//       ],
//       [
//         78.0784514758,
//         11.793060617
//       ],
//       [
//         78.086218566,
//         11.7393266478
//       ],
//       [
//         78.0939872632,
//         11.6855248891
//       ],
//       [
//         78.1017589497,
//         11.6316456701
//       ],
//       [
//         78.1095350105,
//         11.5776792605
//       ],
//       [
//         78.1642567738,
//         11.585428787
//       ],
//       [
//         78.218895063,
//         11.5931506983
//       ],
//       [
//         78.2734597118,
//         11.6008464482
//       ],
//       [
//         78.3279604975,
//         11.6085174711
//       ],
//       [
//         78.382407148,
//         11.6161651832
//       ],
//       [
//         78.43680935,
//         11.6237909837
//       ],
//       [
//         78.4911767557,
//         11.6313962559
//       ],
//       [
//         78.545518991,
//         11.6389823681
//       ],
//       [
//         78.5998456621,
//         11.6465506751
//       ],
//       [
//         78.6541663634,
//         11.6541025188
//       ],
//       [
//         78.7084906843,
//         11.6616392294
//       ],
//       [
//         78.7628282171,
//         11.6691621265
//       ],
//       [
//         78.8171885637,
//         11.6766725201
//       ],
//       [
//         78.871581343,
//         11.6841717112
//       ],
//       [
//         78.9260161987,
//         11.6916609933
//       ],
//       [
//         78.9805028062,
//         11.699141653
//       ],
//       [
//         79.03505088,
//         11.7066149712
//       ],
//       [
//         79.0896701817,
//         11.7140822236
//       ],
//       [
//         79.144370527,
//         11.7215446821
//       ],
//       [
//         79.1991617938,
//         11.7290036154
//       ],
//       [
//         79.1915062212,
//         11.7829866084
//       ],
//       [
//         79.1838649157,
//         11.8368838027
//       ],
//       [
//         79.1762364761,
//         11.890704926
//       ],
//       [
//         79.1686195112,
//         11.944459648
//       ],
//       [
//         79.1610126386,
//         11.9981575871
//       ],
//       [
//         79.1534144835,
//         12.0518083183
//       ],
//       [
//         79.1458236781,
//         12.1054213806
//       ],
//       [
//         79.1382388596,
//         12.1590062842
//       ],
//       [
//         79.1306586703,
//         12.2125725178
//       ],
//       [
//         79.1230817555,
//         12.2661295558
//       ],
//       [
//         79.115506763,
//         12.3196868657
//       ],
//       [
//         79.1079323422,
//         12.3732539151
//       ],
//       [
//         79.1003571426,
//         12.4268401791
//       ],
//       [
//         79.0927798129,
//         12.4804551473
//       ],
//       [
//         79.0851990002,
//         12.5341083311
//       ],
//       [
//         79.0776133489,
//         12.5878092713
//       ],
//       [
//         79.0700214993,
//         12.6415675449
//       ],
//       [
//         79.0624220869,
//         12.695392773
//       ],
//       [
//         79.0548137413,
//         12.7492946279
//       ],
//       [
//         79.0471950848,
//         12.8032828407
//       ],
//       [
//         78.9921976542,
//         12.7957095811
//       ],
//       [
//         78.9372904282,
//         12.7881418774
//       ],
//       [
//         78.8824634912,
//         12.7805784013
//       ],
//       [
//         78.8277069891,
//         12.7730178276
//       ],
//       [
//         78.7730111215,
//         12.765458834
//       ],
//       [
//         78.7183661345,
//         12.7579000993
//       ],
//       [
//         78.6637623126,
//         12.7503403031
//       ],
//       [
//         78.6091899719,
//         12.7427781242
//       ],
//       [
//         78.554639452,
//         12.7352122402
//       ],
//       [
//         78.5001011091,
//         12.7276413259
//       ],
//       [
//         78.4455653085,
//         12.7200640528
//       ],
//       [
//         78.3910224173,
//         12.7124790879
//       ],
//       [
//         78.3364627971,
//         12.7048850926
//       ],
//       [
//         78.2818767965,
//         12.6972807219
//       ],
//       [
//         78.227254744,
//         12.6896646233
//       ],
//       [
//         78.1725869405,
//         12.6820354355
//       ],
//       [
//         78.1178636517,
//         12.6743917878
//       ],
//       [
//         78.0630751009,
//         12.6667322986
//       ],
//       [
//         78.0082114612,
//         12.6590555748
//       ],
//       [
//         77.9532628479,
//         12.6513602099
//       ],
//       [
//         77.9611940967,
//         12.5974155936
//       ]
//     ],
//     [
//       [
//         77.8305391188,
//         13.2039726336
//       ],
//       [
//         77.8384915708,
//         13.1501274843
//       ],
//       [
//         77.8464242493,
//         13.0963574257
//       ],
//       [
//         77.8543386329,
//         13.0426528024
//       ],
//       [
//         77.8622361864,
//         12.9890040095
//       ],
//       [
//         77.8701183619,
//         12.9354014844
//       ],
//       [
//         77.8779866001,
//         12.8818357003
//       ],
//       [
//         77.8858423314,
//         12.8282971582
//       ],
//       [
//         77.8936869768,
//         12.7747763802
//       ],
//       [
//         77.9015219493,
//         12.7212639016
//       ],
//       [
//         77.909348655,
//         12.6677502644
//       ],
//       [
//         77.9171684941,
//         12.6142260095
//       ],
//       [
//         77.9249828619,
//         12.56068167
//       ],
//       [
//         77.93279315,
//         12.5071077637
//       ],
//       [
//         77.9406007472,
//         12.4534947857
//       ],
//       [
//         77.9484070411,
//         12.3998332017
//       ],
//       [
//         77.9562134183,
//         12.3461134399
//       ],
//       [
//         77.9640212662,
//         12.2923258845
//       ],
//       [
//         77.9718319737,
//         12.2384608673
//       ],
//       [
//         77.9796469324,
//         12.1845086607
//       ],
//       [
//         78.0344779627,
//         12.1922787685
//       ],
//       [
//         78.0892255273,
//         12.2000206789
//       ],
//       [
//         78.1438994781,
//         12.2077358517
//       ],
//       [
//         78.1985096104,
//         12.2154257269
//       ],
//       [
//         78.2530656702,
//         12.2230917256
//       ],
//       [
//         78.3075773624,
//         12.2307352519
//       ],
//       [
//         78.3620543575,
//         12.2383576932
//       ],
//       [
//         78.4165062995,
//         12.2459604218
//       ],
//       [
//         78.4709428131,
//         12.2535447959
//       ],
//       [
//         78.5253735112,
//         12.2611121606
//       ],
//       [
//         78.5798080017,
//         12.2686638488
//       ],
//       [
//         78.6342558956,
//         12.2762011825
//       ],
//       [
//         78.6887268135,
//         12.2837254735
//       ],
//       [
//         78.7432303936,
//         12.2912380245
//       ],
//       [
//         78.7977762984,
//         12.2987401303
//       ],
//       [
//         78.8523742228,
//         12.3062330782
//       ],
//       [
//         78.9070339008,
//         12.3137181495
//       ],
//       [
//         78.9617651136,
//         12.3211966201
//       ],
//       [
//         79.0165776969,
//         12.3286697614
//       ],
//       [
//         79.0714815488,
//         12.3361388414
//       ],
//       [
//         79.0637983633,
//         12.3901092051
//       ],
//       [
//         79.0561293285,
//         12.4439937723
//       ],
//       [
//         79.0484730392,
//         12.4978022684
//       ],
//       [
//         79.0408280996,
//         12.5515443604
//       ],
//       [
//         79.0331931228,
//         12.6052296644
//       ],
//       [
//         79.0255667297,
//         12.658867753
//       ],
//       [
//         79.0179475474,
//         12.7124681626
//       ],
//       [
//         79.0103342086,
//         12.7660404008
//       ],
//       [
//         79.0027253506,
//         12.819593954
//       ],
//       [
//         78.9951196137,
//         12.873138294
//       ],
//       [
//         78.9875156407,
//         12.9266828858
//       ],
//       [
//         78.9799120757,
//         12.9802371945
//       ],
//       [
//         78.9723075628,
//         13.0338106925
//       ],
//       [
//         78.9647007454,
//         13.087412867
//       ],
//       [
//         78.957090265,
//         13.1410532269
//       ],
//       [
//         78.9494747602,
//         13.1947413102
//       ],
//       [
//         78.9418528655,
//         13.2484866913
//       ],
//       [
//         78.9342232104,
//         13.3022989886
//       ],
//       [
//         78.9265844184,
//         13.3561878717
//       ],
//       [
//         78.9189351056,
//         13.4101630691
//       ],
//       [
//         78.863813551,
//         13.4025781288
//       ],
//       [
//         78.808782568,
//         13.394998203
//       ],
//       [
//         78.7538322184,
//         13.3874219638
//       ],
//       [
//         78.6989526259,
//         13.3798480862
//       ],
//       [
//         78.6441339681,
//         13.3722752475
//       ],
//       [
//         78.5893664692,
//         13.3647021258
//       ],
//       [
//         78.5346403921,
//         13.3571273994
//       ],
//       [
//         78.4799460314,
//         13.3495497459
//       ],
//       [
//         78.4252737056,
//         13.3419678408
//       ],
//       [
//         78.3706137496,
//         13.3343803568
//       ],
//       [
//         78.3159565079,
//         13.3267859626
//       ],
//       [
//         78.2612923267,
//         13.3191833222
//       ],
//       [
//         78.2066115467,
//         13.3115710937
//       ],
//       [
//         78.1519044959,
//         13.3039479281
//       ],
//       [
//         78.0971614824,
//         13.2963124686
//       ],
//       [
//         78.0423727863,
//         13.2886633495
//       ],
//       [
//         77.987528653,
//         13.280999195
//       ],
//       [
//         77.9326192853,
//         13.273318618
//       ],
//       [
//         77.8776348359,
//         13.2656202194
//       ],
//       [
//         77.8225653996,
//         13.2579025868
//       ],
//       [
//         77.8305391188,
//         13.2039726336
//       ]
//     ],
//     [
//       [
//         77.6993757793,
//         13.81048956
//       ],
//       [
//         77.7073725596,
//         13.7566590054
//       ],
//       [
//         77.7153493083,
//         13.7029034938
//       ],
//       [
//         77.7233075133,
//         13.6492133729
//       ],
//       [
//         77.7312486482,
//         13.5955790405
//       ],
//       [
//         77.7391741739,
//         13.5419909374
//       ],
//       [
//         77.7470855396,
//         13.4884395396
//       ],
//       [
//         77.7549841842,
//         13.4349153509
//       ],
//       [
//         77.7628715368,
//         13.3814088964
//       ],
//       [
//         77.7707490188,
//         13.3279107143
//       ],
//       [
//         77.778618044,
//         13.2744113493
//       ],
//       [
//         77.7864800205,
//         13.2209013454
//       ],
//       [
//         77.7943363513,
//         13.1673712384
//       ],
//       [
//         77.8021884356,
//         13.1138115487
//       ],
//       [
//         77.8100376698,
//         13.0602127746
//       ],
//       [
//         77.8178854485,
//         13.0065653842
//       ],
//       [
//         77.8257331658,
//         12.9528598088
//       ],
//       [
//         77.8335822162,
//         12.8990864352
//       ],
//       [
//         77.8414339957,
//         12.845235598
//       ],
//       [
//         77.8492899027,
//         12.7912975725
//       ],
//       [
//         77.9042369532,
//         12.7990892244
//       ],
//       [
//         77.9591005391,
//         12.8068520933
//       ],
//       [
//         78.0138905314,
//         12.8145876451
//       ],
//       [
//         78.0686167446,
//         12.8222973252
//       ],
//       [
//         78.1232889442,
//         12.8299825604
//       ],
//       [
//         78.1779168541,
//         12.8376447592
//       ],
//       [
//         78.2325101645,
//         12.8452853137
//       ],
//       [
//         78.2870785387,
//         12.8529056003
//       ],
//       [
//         78.341631621,
//         12.8605069808
//       ],
//       [
//         78.3961790438,
//         12.8680908035
//       ],
//       [
//         78.450730435,
//         12.8756584043
//       ],
//       [
//         78.5052954252,
//         12.8832111076
//       ],
//       [
//         78.5598836551,
//         12.8907502275
//       ],
//       [
//         78.6145047831,
//         12.8982770683
//       ],
//       [
//         78.669168492,
//         12.905792926
//       ],
//       [
//         78.723884497,
//         12.9132990892
//       ],
//       [
//         78.7786625531,
//         12.9207968396
//       ],
//       [
//         78.8335124623,
//         12.9282874533
//       ],
//       [
//         78.8884440814,
//         12.9357722016
//       ],
//       [
//         78.9434673299,
//         12.943252352
//       ],
//       [
//         78.9357545861,
//         12.9972101238
//       ],
//       [
//         78.9280558781,
//         13.0510821013
//       ],
//       [
//         78.9203697956,
//         13.1048780076
//       ],
//       [
//         78.9126949384,
//         13.158607507
//       ],
//       [
//         78.9050299145,
//         13.2122802133
//       ],
//       [
//         78.8973733399,
//         13.2659056965
//       ],
//       [
//         78.8897238368,
//         13.3194934905
//       ],
//       [
//         78.8820800326,
//         13.3730531006
//       ],
//       [
//         78.8744405594,
//         13.4265940106
//       ],
//       [
//         78.8668040522,
//         13.4801256899
//       ],
//       [
//         78.8591691484,
//         13.5336576008
//       ],
//       [
//         78.8515344863,
//         13.5871992061
//       ],
//       [
//         78.8438987045,
//         13.6407599756
//       ],
//       [
//         78.8362604405,
//         13.6943493938
//       ],
//       [
//         78.82861833,
//         13.7479769671
//       ],
//       [
//         78.8209710052,
//         13.801652231
//       ],
//       [
//         78.8133170947,
//         13.8553847572
//       ],
//       [
//         78.8056552216,
//         13.9091841614
//       ],
//       [
//         78.7979840027,
//         13.9630601106
//       ],
//       [
//         78.7903020476,
//         14.0170223305
//       ],
//       [
//         78.7350494358,
//         14.0094247697
//       ],
//       [
//         78.6798877764,
//         14.0018316814
//       ],
//       [
//         78.6248071076,
//         13.9942417376
//       ],
//       [
//         78.5697975294,
//         13.9866536135
//       ],
//       [
//         78.5148491963,
//         13.9790659858
//       ],
//       [
//         78.4599523093,
//         13.9714775317
//       ],
//       [
//         78.4050971087,
//         13.9638869284
//       ],
//       [
//         78.3502738664,
//         13.9562928516
//       ],
//       [
//         78.2954728782,
//         13.9486939749
//       ],
//       [
//         78.2406844571,
//         13.9410889684
//       ],
//       [
//         78.185898925,
//         13.9334764983
//       ],
//       [
//         78.1311066063,
//         13.9258552252
//       ],
//       [
//         78.0762978197,
//         13.9182238035
//       ],
//       [
//         78.0214628715,
//         13.9105808804
//       ],
//       [
//         77.9665920478,
//         13.9029250947
//       ],
//       [
//         77.9116756071,
//         13.8952550758
//       ],
//       [
//         77.8567037731,
//         13.8875694427
//       ],
//       [
//         77.8016667269,
//         13.8798668027
//       ],
//       [
//         77.7465545996,
//         13.8721457506
//       ],
//       [
//         77.6913574644,
//         13.8644048676
//       ],
//       [
//         77.6993757793,
//         13.81048956
//       ]
//     ],
//     [
//       [
//         77.5676803283,
//         14.4169631544
//       ],
//       [
//         77.575723596,
//         14.36314718
//       ],
//       [
//         77.5837465667,
//         14.3094062007
//       ],
//       [
//         77.5917507378,
//         14.2557305672
//       ],
//       [
//         77.5997375924,
//         14.2021106804
//       ],
//       [
//         77.6077086004,
//         14.1485369839
//       ],
//       [
//         77.6156652201,
//         14.0949999567
//       ],
//       [
//         77.623608899,
//         14.0414901057
//       ],
//       [
//         77.6315410753,
//         13.9879979587
//       ],
//       [
//         77.6394631784,
//         13.9345140568
//       ],
//       [
//         77.6473766308,
//         13.8810289477
//       ],
//       [
//         77.6552828487,
//         13.827533178
//       ],
//       [
//         77.6631832432,
//         13.7740172864
//       ],
//       [
//         77.6710792214,
//         13.7204717963
//       ],
//       [
//         77.6789721877,
//         13.6668872084
//       ],
//       [
//         77.6868635443,
//         13.613253994
//       ],
//       [
//         77.694754693,
//         13.5595625869
//       ],
//       [
//         77.7026470357,
//         13.5058033767
//       ],
//       [
//         77.7105419759,
//         13.4519667009
//       ],
//       [
//         77.7184409194,
//         13.3980428375
//       ],
//       [
//         77.77351081,
//         13.4058570078
//       ],
//       [
//         77.8284972295,
//         13.4136418058
//       ],
//       [
//         77.8834100693,
//         13.4213987034
//       ],
//       [
//         77.9382591645,
//         13.4291291522
//       ],
//       [
//         77.9930543011,
//         13.4368345841
//       ],
//       [
//         78.0478052234,
//         13.444516413
//       ],
//       [
//         78.1025216422,
//         13.4521760353
//       ],
//       [
//         78.1572132414,
//         13.4598148318
//       ],
//       [
//         78.2118896861,
//         13.467434168
//       ],
//       [
//         78.2665606293,
//         13.4750353958
//       ],
//       [
//         78.32123572,
//         13.482619854
//       ],
//       [
//         78.3759246099,
//         13.4901888698
//       ],
//       [
//         78.4306369608,
//         13.4977437594
//       ],
//       [
//         78.4853824523,
//         13.5052858292
//       ],
//       [
//         78.5401707889,
//         13.5128163766
//       ],
//       [
//         78.5950117074,
//         13.5203366913
//       ],
//       [
//         78.6499149848,
//         13.5278480558
//       ],
//       [
//         78.7048904451,
//         13.5353517465
//       ],
//       [
//         78.7599479675,
//         13.5428490348
//       ],
//       [
//         78.8150974941,
//         13.5503411877
//       ],
//       [
//         78.8073532165,
//         13.6042864033
//       ],
//       [
//         78.7996228604,
//         13.6581458266
//       ],
//       [
//         78.7919050107,
//         13.7119291784
//       ],
//       [
//         78.7841982619,
//         13.7656461206
//       ],
//       [
//         78.7765012169,
//         13.8193062643
//       ],
//       [
//         78.7688124863,
//         13.8729191773
//       ],
//       [
//         78.7611306869,
//         13.926494391
//       ],
//       [
//         78.7534544408,
//         13.9800414082
//       ],
//       [
//         78.7457823743,
//         14.0335697102
//       ],
//       [
//         78.7381131167,
//         14.0870887639
//       ],
//       [
//         78.7304452996,
//         14.1406080292
//       ],
//       [
//         78.7227775554,
//         14.1941369662
//       ],
//       [
//         78.7151085166,
//         14.2476850424
//       ],
//       [
//         78.7074368145,
//         14.3012617396
//       ],
//       [
//         78.6997610785,
//         14.3548765618
//       ],
//       [
//         78.6920799344,
//         14.4085390416
//       ],
//       [
//         78.6843920042,
//         14.4622587484
//       ],
//       [
//         78.6766959041,
//         14.5160452951
//       ],
//       [
//         78.6689902442,
//         14.569908346
//       ],
//       [
//         78.6612736269,
//         14.6238576242
//       ],
//       [
//         78.6058829469,
//         14.6162464936
//       ],
//       [
//         78.5505836145,
//         14.6086392922
//       ],
//       [
//         78.4953656427,
//         14.6010346925
//       ],
//       [
//         78.4402191068,
//         14.5934313692
//       ],
//       [
//         78.3851341368,
//         14.5858279983
//       ],
//       [
//         78.3301009096,
//         14.5782232561
//       ],
//       [
//         78.2751096413,
//         14.5706158183
//       ],
//       [
//         78.2201505798,
//         14.5630043589
//       ],
//       [
//         78.1652139976,
//         14.5553875492
//       ],
//       [
//         78.1102901838,
//         14.5477640568
//       ],
//       [
//         78.0553694372,
//         14.5401325447
//       ],
//       [
//         78.0004420587,
//         14.5324916704
//       ],
//       [
//         77.9454983441,
//         14.5248400844
//       ],
//       [
//         77.8905285766,
//         14.5171764297
//       ],
//       [
//         77.8355230191,
//         14.5094993407
//       ],
//       [
//         77.7804719074,
//         14.5018074416
//       ],
//       [
//         77.7253654423,
//         14.4940993461
//       ],
//       [
//         77.670193782,
//         14.4863736557
//       ],
//       [
//         77.6149470348,
//         14.4786289592
//       ],
//       [
//         77.559615251,
//         14.4708638307
//       ],
//       [
//         77.5676803283,
//         14.4169631544
//       ]
//     ]
//   ]
// ];

// const TestPage = () => {
//     const mapRef = useRef(null);
//     const mapInstanceRef = useRef(null);
//     const polygonLayersRef = useRef([]);
  
//     useEffect(() => {
//       // Ensure the map div exists and map hasn't been initialized
//       if (!mapRef.current || mapInstanceRef.current) return;
  
//       // Initialize map
//       mapInstanceRef.current = L.map(mapRef.current).setView([13.0, 77.0], 8);
  
//       // Add OpenStreetMap tiles
//       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         attribution: '© OpenStreetMap contributors'
//       }).addTo(mapInstanceRef.current);
  
//       // Style for the polygons
//       const polygonStyle = {
//         color: '#ff4444',
//         weight: 2,
//         opacity: 0.8,
//         fillColor: '#ff4444',
//         fillOpacity: 0.2
//       };
  
//       // Safely handle polygon data
//       if (Array.isArray(polygonCoords) && polygonCoords.length > 0) {
//         // Add each polygon to the map
//         polygonCoords.forEach(coords => {
//           if (Array.isArray(coords) && coords.length > 0) {
//             const polygon = L.polygon(coords, polygonStyle);
//             polygon.addTo(mapInstanceRef.current);
//             polygonLayersRef.current.push(polygon);
//           }
//         });
  
//         // Calculate bounds from all layers
//         const group = L.featureGroup(polygonLayersRef.current);
//         const bounds = group.getBounds();
//         mapInstanceRef.current.fitBounds(bounds);
//       }
  
//       // Cleanup function
//       return () => {
//         if (mapInstanceRef.current) {
//           // Clean up polygon layers
//           polygonLayersRef.current.forEach(layer => {
//             layer.remove();
//           });
//           polygonLayersRef.current = [];
  
//           // Remove map
//           mapInstanceRef.current.remove();
//           mapInstanceRef.current = null;
//         }
//       };
//     }, []); // Empty dependency array since we only want to run this once
  
//     return (
//       <div 
//         ref={mapRef} 
//         style={{ 
//           height: "600px", 
//           width: "100%", 
//           margin: "20px 0",
//           backgroundColor: "#f0f0f0" // Added to show map container before map loads
//         }}
//         className="rounded-lg shadow-md" 
//       />
//     );
//   };
  
//   export default TestPage;


// import React, { useEffect, useRef } from 'react';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';

// const TestPage = () => {
//   // Use useRef instead of useState to prevent re-renders
//   const mapRef = useRef(null);
//   const mapContainerRef = useRef(null);

//   useEffect(() => {
//     // Only initialize the map if it hasn't been initialized yet
//     if (mapContainerRef.current && !mapRef.current) {
//       // Create map instance
//       mapRef.current = L.map(mapContainerRef.current).setView([11.3, 76.9], 19);
      
//       // Add OpenStreetMap as a base layer
//       const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//         maxZoom: 19
//       });
//       osm.addTo(mapRef.current);
      
//       // Add your XYZ tiles from GeoTIFF
//       // Replace this URL with the path to your tiles
//       const tiffLayer = L.tileLayer('http://localhost:8001/{z}/{x}/{y}.png', {
//         minZoom: 8,
//         maxZoom: 19,
//         tms: true,  // Set to true if your tiles follow TMS convention (typically needed for gdal2tiles output)
//         opacity: 1,
//         attribution: 'My GeoTIFF Data'
//       });
//       tiffLayer.addTo(mapRef.current);
      
//       // Add layer controls
//       const baseLayers = {
//         "OpenStreetMap": osm
//       };
      
//       const overlays = {
//         "GeoTIFF Layer": tiffLayer
//       };
      
//       L.control.layers(baseLayers, overlays).addTo(mapRef.current);
      
//       // Add scale control
//       L.control.scale().addTo(mapRef.current);
      
//       // Add info box
//       const info = L.control({position: 'bottomright'});
      
//       info.onAdd = function() {
//         const div = L.DomUtil.create('div', 'info');
//         div.innerHTML = '<h4>My QGIS GeoTIFF Map</h4>' +
//           'Zoom and pan to explore the data';
//         return div;
//       };
      
//       info.addTo(mapRef.current);
      
//       // Add legend
//       const legend = L.control({position: 'bottomleft'});
      
//       legend.onAdd = function() {
//         const div = L.DomUtil.create('div', 'legend');
//         div.innerHTML = '<h4>Legend</h4>' +
//           '<div style="background-color: #ff0000; width: 20px; height: 20px; display: inline-block;"></div> High Value<br>' +
//           '<div style="background-color: #00ff00; width: 20px; height: 20px; display: inline-block;"></div> Medium Value<br>' +
//           '<div style="background-color: #0000ff; width: 20px; height: 20px; display: inline-block;"></div> Low Value';
//         return div;
//       };
      
//       legend.addTo(mapRef.current);
//     }
    
//     // Clean up on unmount
//     return () => {
//       if (mapRef.current) {
//         mapRef.current.remove();
//         mapRef.current = null;
//       }
//     };
//   }, []); // Empty dependency array to ensure effect runs only once

//   return (
//     <div className="testpage-container">
//       <style jsx>{`
//         .testpage-container {
//           width: 100%;
//           height: 100vh;
//         }
        
//         .map-container {
//           width: 100%;
//           height: 100%;
//         }
        
//         .info {
//           padding: 6px 8px;
//           font: 14px/16px Arial, Helvetica, sans-serif;
//           background: white;
//           background: rgba(255, 255, 255, 0.8);
//           box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
//           border-radius: 5px;
//         }
        
//         .legend {
//           background-color: white;
//           padding: 10px;
//           border-radius: 5px;
//         }
//       `}</style>
//       <div ref={mapContainerRef} className="map-container"></div>
//     </div>
//   );
// };

// export default TestPage;


// import React, { useEffect, useState } from 'react';
// import { Loader2, Target, Calendar, Search, Map, AlertTriangle } from 'lucide-react';

// const AnimatedGuidance = ({ type }) => {
//   const [showComponent, setShowComponent] = useState(false);
  
//   // Animation entrance effect
//   useEffect(() => {
//     setShowComponent(false);
//     const timer = setTimeout(() => {
//       setShowComponent(true);
//     }, 150);
    
//     return () => clearTimeout(timer);
//   }, [type]);
  
//   const renderAnimation = () => {
//     switch (type) {
//       case 'draw-aoi':
//         return (
//           <div className="flex flex-col items-center transition-all duration-500 ease-in-out transform">
//             <div className="relative mb-6">
//               <div className="absolute inset-0 border-2 border-blue-500 rounded-full opacity-50 animate-ping"></div>
//               <div className="absolute inset-0 border border-blue-400 rounded-full opacity-30 animate-pulse"></div>
//               <Target 
//                 size={64} 
//                 className="text-blue-500 relative z-10" 
//                 strokeWidth={1.5} 
//               />
//               <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
//             </div>
//             <span className="text-sm text-gray-400">Draw an Area of Interest on the map</span>
//           </div>
//         );
        
//       case 'select-date':
//         return (
//           <div className="flex flex-col items-center transition-all duration-500 ease-in-out">
//             <div className="relative mb-6">
//               <Calendar 
//                 size={64} 
//                 className="text-blue-500" 
//                 strokeWidth={1.5} 
//               />
//               <div className="absolute -top-2 -right-2 w-5 h-5 bg-blue-500 rounded-full animate-bounce"></div>
              
//               {/* Date highlight animation */}
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <div className="w-8 h-8 border-2 border-blue-400 rounded-sm absolute opacity-0 animate-dateHighlight1"></div>
//                 <div className="w-8 h-8 border-2 border-blue-400 rounded-sm absolute opacity-0 animate-dateHighlight2 animation-delay-500"></div>
//               </div>
//             </div>
//             <span className="text-sm text-gray-400">Select a date range to search for imagery</span>
            
//             <style jsx>{`
//               @keyframes dateHighlight1 {
//                 0% { opacity: 0; transform: scale(0.8); }
//                 20% { opacity: 0.7; transform: scale(1); }
//                 40% { opacity: 0; transform: scale(1.1); }
//                 100% { opacity: 0; }
//               }
//               @keyframes dateHighlight2 {
//                 0% { opacity: 0; transform: scale(0.8); }
//                 20% { opacity: 0.7; transform: scale(1); }
//                 40% { opacity: 0; transform: scale(1.1); }
//                 100% { opacity: 0; }
//               }
//               .animate-dateHighlight1 {
//                 animation: dateHighlight1 3s infinite;
//               }
//               .animate-dateHighlight2 {
//                 animation: dateHighlight2 3s infinite;
//                 animation-delay: 1.5s;
//               }
//               .animation-delay-500 {
//                 animation-delay: 1.5s;
//               }
//             `}</style>
//           </div>
//         );
        
//       case 'loading':
//         return (
//           <div className="flex flex-col items-center transition-all duration-500 ease-in-out">
//             <div className="relative mb-6">
//               <Loader2 
//                 size={64} 
//                 className="text-blue-500 animate-spin" 
//                 strokeWidth={1.5} 
//               />
//               <div className="absolute inset-0 border-4 border-gray-700 border-opacity-20 rounded-full"></div>
//               <div className="absolute inset-0 border-4 border-t-blue-500 border-opacity-40 rounded-full animate-spin" style={{animationDuration: '1.5s'}}></div>
//             </div>
//             <span className="text-sm text-gray-400">Searching for available imagery...</span>
            
//             {/* Small dots moving from left to right */}
//             <div className="flex mt-4 space-x-1">
//               <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0s'}}></div>
//               <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
//               <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
//             </div>
//           </div>
//         );
        
//       case 'no-imagery':
//         return (
//           <div className="flex flex-col items-center transition-all duration-500 ease-in-out">
//             <div className="relative mb-6">
//               <Map 
//                 size={64} 
//                 className="text-gray-400" 
//                 strokeWidth={1.5} 
//               />
//               <div className="absolute top-0 right-0 left-0 bottom-0 flex items-center justify-center">
//                 <AlertTriangle 
//                   size={32} 
//                   className="text-amber-500 animate-pulse" 
//                   strokeWidth={1.5} 
//                 />
//               </div>
//             </div>
//             <span className="text-sm text-gray-400">No imagery found for this area and date range</span>
//             <span className="text-xs text-gray-500 mt-2">Try adjusting your search parameters</span>
//           </div>
//         );
        
//       default:
//         return (
//           <div className="flex flex-col items-center transition-all duration-500 ease-in-out">
//             <Search 
//               size={64} 
//               className="text-blue-500 mb-6" 
//               strokeWidth={1.5} 
//             />
//             <span className="text-sm text-gray-400">Unknown state</span>
//           </div>
//         );
//     }
//   };

//   return (
//     <div className="flex items-center justify-center w-full h-full py-12">
//       <div className={`transition-opacity duration-500 ${showComponent ? 'opacity-100' : 'opacity-0'}`}>
//         {renderAnimation()}
//       </div>
//     </div>
//   );
// };

// export default AnimatedGuidance;


// import React from 'react';

// const TestPage = () => {
//   // This is a simplified component that generates an HTML map with the polygons
//   // We're using direct HTML/JS since the React component had loading issues
  
//   return (
//     <div className="w-full">
//       <div className="text-xl font-bold mb-4 text-center">Polygon Map</div>
      
//       <div className="w-full h-96 rounded-lg shadow-lg overflow-hidden relative" id="map-container">
//         <iframe 
//           srcDoc={`
//             <!DOCTYPE html>
//             <html>
//             <head>
//               <meta charset="utf-8" />
//               <meta name="viewport" content="width=device-width, initial-scale=1.0">
//               <title>Polygon Map</title>
//               <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css" crossorigin="" />
//               <script src="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js" crossorigin=""></script>
//               <style>
//                 body { margin: 0; padding: 0; }
//                 #map { width: 100%; height: 100vh; }
//                 .legend {
//                   background: white;
//                   padding: 10px;
//                   border-radius: 5px;
//                   box-shadow: 0 0 15px rgba(0,0,0,0.2);
//                 }
//                 .legend i {
//                   display: inline-block;
//                   width: 15px;
//                   height: 15px;
//                   margin-right: 5px;
//                 }
//               </style>
//             </head>
//             <body>
//               <div id="map"></div>
//               <script>
//                 // Initialize the map
//                 const map = L.map('map').setView([13.175, 77.584], 9);
                
//                 // Add OpenStreetMap tile layer
//                 L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//                   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                 }).addTo(map);
                
//                 // Define the polygon data
//                 const polygonData = [
//                 [[
//   [13.198594854154791, 77.23036500489718],
//   [12.68417581052806, 77.23036500489718],
//   [12.68417581052806, 77.9676216052203],
//   [13.198594854154791, 77.9676216052203],
//   [13.198594854154791, 77.23036500489718]
// ]],
//                   [[[12.411735737, 78.0023215799], [12.4051136499, 77.9557717478], [12.3984619253, 77.9090779608], [12.391779302, 77.8622319571], [12.3850644965, 77.8152253643], [12.3783162016, 77.7680496927], [12.9976289766, 77.6368219796], [13.6168642005, 77.5050152517], [13.6622870037, 77.4983901875], [13.7076985783, 77.4917559393], [13.7531062602, 77.485111425], [13.7985173828, 77.4784555562], [13.8439392819, 77.471787237], [13.8503729222, 77.5192933226], [13.8567748976, 77.5666290773], [13.8631464518, 77.6138030512], [13.8694888057, 77.660823676], [13.8758031594, 77.7076992724], [13.2564683791, 77.8391286476], [12.6370609231, 77.9700007512], [12.591988691, 77.9764831285], [12.5469273192, 77.9829553424], [12.501869544, 77.9894184534], [12.4568081045, 77.9958735161], [12.411735737, 78.0023215799]]],
// [[[13.6931348697, 77.1687844245], [13.7381053297, 77.1625849967], [13.7830737934, 77.1563890077], [13.8280475031, 77.150195454], [13.8730337047, 77.1440033335], [13.8793387856, 77.1905987378], [13.8856535181, 77.2373272964], [13.8919789274, 77.2841971642], [13.8983160461, 77.3312165974], [13.9046659151, 77.3783939602], [13.28470339, 77.5049855767], [12.6647018401, 77.6312703868], [12.6193760789, 77.6374119809], [12.574063089, 77.6435570416], [12.5287555554, 77.6497065633], [12.4834461663, 77.655861543], [12.4381276092, 77.6620229814], [12.4321316755, 77.6150823516], [12.4261466155, 77.5682986542], [12.4201714574, 77.5216635696], [12.4142052363, 77.4751688852], [12.4082469935, 77.4288064894], [13.0282228818, 77.3020622689], [13.6481551696, 77.174988297], [13.6931348697, 77.1687844245]]],
// [[[13.7030430815, 77.0116660447], [13.7477227313, 77.0054481451], [13.7924001184, 76.9992315309], [13.8370824261, 76.9930151956], [13.8817768406, 76.9867981328], [13.8879967402, 77.0327578258], [13.8942198951, 77.0788016212], [13.9004472912, 77.1249371805], [13.9066799176, 77.1711722295], [13.9129187671, 77.2175145636], [13.2930288507, 77.3448821588], [12.6730935, 77.4719023783], [12.6281723045, 77.4780493808], [12.5832634473, 77.4841976087], [12.538359696, 77.4903480567], [12.4934538216, 77.4965017208], [12.4485385938, 77.5026595991], [12.4425450094, 77.4565641383], [12.4365563996, 77.4105752361], [12.4305718171, 77.3646851403], [12.4245903174, 77.3188861677], [12.4186109583, 77.2731706986], [13.0385074572, 77.1457133065], [13.6583539846, 77.0178862371], [13.7030430815, 77.0116660447]]],
// [[[12.435399483, 78.2105058657], [12.4288516031, 78.1642285055], [12.4222766835, 78.1178240767], [12.4156735094, 78.0712845264], [12.4090408458, 78.0246017047], [12.4023774362, 77.9777673585], [13.0217271815, 77.8467525484], [13.6410000151, 77.7151714939], [13.686259788, 77.7085881412], [13.7315084921, 77.7019964093], [13.7767534298, 77.6953952245], [13.822001901, 77.6887835069], [13.8672612079, 77.68216017], [13.8736470085, 77.729318854], [13.880003653, 77.7763249098], [13.8863323425, 77.8231866485], [13.8926342579, 77.8699122772], [13.8989105609, 77.9165099051], [13.2795395514, 78.0477080552], [12.6600964485, 78.1783615983], [12.6151496814, 78.1848071367], [12.5702138386, 78.1912432823], [12.5252816819, 78.197671088], [12.480345976, 78.2040916015], [12.435399483, 78.2105058657]]],
//                 ];
                
//                 // Define colors for polygons
//                 const colors = ['#FF5733', '#33FF57', '#3357FF', '#F3FF33', '#FF33F3', '#33FFF3'];
                
//                 // Add polygons to the map
//                 polygonData.forEach((polygon, index) => {
//                   // For Leaflet polygons, we need to use the coordinates directly
//                   const latLngs = polygon[0].map(point => [point[0], point[1]]);
                  
//                   L.polygon(latLngs, {
//                     color: colors[index % colors.length],
//                     fillOpacity: 0.5,
//                     weight: 2
//                   }).addTo(map).bindPopup("Polygon " + (index + 1));
//                 });
                
//                 // Add a legend
//                 const legend = L.control({position: 'bottomright'});
//                 legend.onAdd = function(map) {
//                   const div = L.DomUtil.create('div', 'legend');
//                   div.innerHTML = '<strong>Polygons</strong><br>';
                  
//                   for (let i = 0; i < polygonData.length; i++) {
//                     div.innerHTML += 
//                       '<i style="background:' + colors[i % colors.length] + '"></i> ' +
//                       'Polygon ' + (i + 1) + '<br>';
//                   }
                  
//                   return div;
//                 };
//                 legend.addTo(map);
//               </script>
//             </body>
//             </html>
//           `}
//           className="w-full h-full border-0"
//           title="Polygon Map"
//         />
//       </div>
      
//       <div className="mt-4 text-sm text-gray-600 text-center">
//         The map shows 6 polygons in the Bangalore region based on the provided coordinates. 
//         Click on a polygon to see its number.
//       </div>
//     </div>
//   );
// };

// export default TestPage;


import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Slider, Box, Typography, FormControlLabel, Switch } from '@mui/material';

// We'll generate grid cell data instead of point data
const generateGridData = (centerLat, centerLng, gridSize, intensity) => {
  const grid = [];
  const cellSize = 0.01; // Approximately 1km at the equator
  
  for (let i = -gridSize/2; i < gridSize/2; i++) {
    for (let j = -gridSize/2; j < gridSize/2; j++) {
      // Create grid cells with different intensities
      // Distance from center affects intensity
      const distance = Math.sqrt(i*i + j*j);
      let cellIntensity = Math.max(0, intensity * (1 - distance/(gridSize/2)));
      
      // Add some randomness for more realistic patterns
      cellIntensity = Math.min(1, Math.max(0, cellIntensity + (Math.random() * 0.3 - 0.15)));
      
      grid.push({
        bounds: [
          [centerLat + i * cellSize, centerLng + j * cellSize],
          [centerLat + (i+1) * cellSize, centerLng + j * cellSize],
          [centerLat + (i+1) * cellSize, centerLng + (j+1) * cellSize],
          [centerLat + i * cellSize, centerLng + (j+1) * cellSize]
        ],
        intensity: cellIntensity
      });
    }
  }
  return grid;
};

// Generate simulated grid data for different dates
const simulatedGridData = {
  '2025-01-01': [
    ...generateGridData(33.45, -112.07, 50, 0.9), // Phoenix
    ...generateGridData(40.71, -74.00, 40, 0.7),  // New York
    ...generateGridData(34.05, -118.24, 30, 0.6)  // Los Angeles
  ],
  '2025-01-15': [
    ...generateGridData(33.45, -112.07, 50, 0.6), // Phoenix reduced
    ...generateGridData(40.71, -74.00, 40, 0.9),  // New York increased
    ...generateGridData(34.05, -118.24, 30, 0.7)  // Los Angeles increased
  ],
  '2025-02-01': [
    ...generateGridData(33.45, -112.07, 50, 0.8), // Phoenix increased
    ...generateGridData(40.71, -74.00, 40, 0.5),  // New York decreased
    ...generateGridData(34.05, -118.24, 30, 0.9)  // Los Angeles increased more
  ]
};

const dateKeys = Object.keys(simulatedGridData);

// Function to get color based on intensity value
const getColor = (intensity) => {
  // This color scheme approximates the one in your reference image
  if (intensity > 0.8) return '#FF4136'; // red
  if (intensity > 0.6) return '#FF851B'; // orange
  if (intensity > 0.4) return '#FFDC00'; // yellow
  if (intensity > 0.2) return '#2ECC40'; // light green/blue
  return '#0074D9';  // blue
};

const GridHeatmap = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const gridLayerRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mapReady, setMapReady] = useState(false);
  const [useSatellite, setUseSatellite] = useState(false);
  const [opacity, setOpacity] = useState(0.7);

  // Initialize map
  useEffect(() => {
    if (!mapContainerRef.current) return;
    
    // Initialize the map centered on Phoenix
    const map = L.map(mapContainerRef.current).setView([33.45, -112.07], 10);
    
    // Store map reference
    mapRef.current = map;
    
    // Set initial tiles based on useSatellite state
    updateMapTiles(map, useSatellite);
    
    // Wait for map to be ready
    map.whenReady(() => {
      setMapReady(true);
    });
    
    // Cleanup on unmount
    return () => {
      if (map) {
        map.remove();
      }
    };
  }, []);

  // Function to update map tiles
  const updateMapTiles = (map, useSatelliteView) => {
    // Remove existing tile layers
    map.eachLayer(layer => {
      if (layer instanceof L.TileLayer) {
        map.removeLayer(layer);
      }
    });

    if (useSatelliteView) {
      // ESRI World Imagery (satellite)
      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
      }).addTo(map);
    } else {
      // Light/minimal basemap to let the heatmap colors stand out
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
      }).addTo(map);
    }
  };

  // Toggle between satellite and map view
  useEffect(() => {
    if (!mapRef.current) return;
    updateMapTiles(mapRef.current, useSatellite);
  }, [useSatellite]);

  // Create or update grid cells
  useEffect(() => {
    if (!mapReady || !mapRef.current) return;
    
    // Remove previous grid layer if exists
    if (gridLayerRef.current) {
      mapRef.current.removeLayer(gridLayerRef.current);
    }
    
    // Create a new layer group
    const layerGroup = L.layerGroup();
    gridLayerRef.current = layerGroup;
    
    // Get current grid data
    const currentData = simulatedGridData[dateKeys[selectedIndex]];
    
    // Add grid cells to the map
    currentData.forEach(cell => {
      // Create polygon for each cell
      const polygon = L.polygon(cell.bounds, {
        color: 'white',
        weight: 0.3,
        fillColor: getColor(cell.intensity),
        fillOpacity: opacity,
        opacity: 0.5
      });
      
      // Add tooltip showing intensity value
      polygon.bindTooltip(`Intensity: ${(cell.intensity * 100).toFixed(0)}%`);
      
      // Add to layer group
      layerGroup.addLayer(polygon);
    });
    
    // Add layer group to map
    layerGroup.addTo(mapRef.current);
    
  }, [mapReady, selectedIndex, opacity, useSatellite]);

  return (
    <Box>
      <div 
        ref={mapContainerRef} 
        id="gridmap" 
        style={{ height: '80vh', width: '100%' }}
      ></div>
      <Box sx={{ px: 4, py: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" gutterBottom>
            Satellite Grid Coverage: {dateKeys[selectedIndex]}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={useSatellite}
                onChange={(e) => setUseSatellite(e.target.checked)}
                name="satelliteView"
                color="primary"
              />
            }
            label="Satellite View"
          />
        </Box>
        
        <Typography gutterBottom>Time Period</Typography>
        <Slider
          value={selectedIndex}
          min={0}
          max={dateKeys.length - 1}
          onChange={(e, val) => setSelectedIndex(val)}
          step={1}
          marks={dateKeys.map((date, idx) => ({ value: idx, label: date.slice(5) }))}
          sx={{ mb: 3 }}
        />
        
        <Typography gutterBottom>Grid Opacity: {(opacity * 100).toFixed(0)}%</Typography>
        <Slider
          value={opacity}
          min={0.1}
          max={1.0}
          step={0.1}
          onChange={(e, val) => setOpacity(val)}
          marks={[
            { value: 0.1, label: '10%' },
            { value: 0.5, label: '50%' },
            { value: 1.0, label: '100%' }
          ]}
        />
      </Box>
    </Box>
  );
};

export default GridHeatmap;